import { useEffect, useRef, useState } from "react";

export default function MultiSelect({ label, options = [], value = [], onChange, testid }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const ref = useRef(null);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);
  const toggle = (o) => onChange(value.includes(o) ? value.filter((x) => x !== o) : [...value, o]);
  const shown = options.filter((o) => String(o).toLowerCase().includes(q.toLowerCase()));
  return (
    <div className={`ms ${value.length ? "has" : ""}`} ref={ref} data-testid={testid}>
      <button type="button" className="ms-btn" onClick={() => setOpen(!open)} data-testid={`${testid}-btn`}>{label}{value.length ? ` (${value.length})` : ""} <span className="ms-caret">▾</span></button>
      {open && <div className="ms-pop">
        <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari... / 搜索" data-testid={`${testid}-search`} />
        <div className="ms-actions"><button type="button" onClick={() => onChange(shown)}>Pilih semua</button><button type="button" onClick={() => onChange([])}>Kosongkan</button></div>
        <div className="ms-list">
          {shown.length === 0 && <div className="muted small">Tidak ada pilihan</div>}
          {shown.map((o) => <label key={o} className="ms-item"><input type="checkbox" checked={value.includes(o)} onChange={() => toggle(o)} data-testid={`${testid}-opt-${String(o).replace(/[^A-Za-z0-9]/g, "_")}`} /> <span>{o}</span></label>)}
        </div>
      </div>}
    </div>
  );
}
